import db from "@/database";

export const findAll = () => {
  return db.symptom.orderBy("name").toArray();
};

export const findOne = (id) => {
  return db.symptom.get(id);
};
